import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormMultiselectComponent} from '@shared/components/inputs/form-multiselect/form-multiselect.component';
import {TranslateModule} from '@ngx-translate/core';
import {InfoBullWidgetComponentModule} from '@shared/components/widgets/info-bull-widget/info-bull-widget.component.module';
import {MultiSelectModule} from 'primeng/multiselect';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ListFormErrorComponentModule} from '@shared/components/error/list-form-error/list-form-error.component.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        InfoBullWidgetComponentModule,
        MultiSelectModule,
        FormsModule,
        ReactiveFormsModule,
        ListFormErrorComponentModule,
    ],
    declarations: [
        FormMultiselectComponent,
    ],
    exports: [
        FormMultiselectComponent,
        TranslateModule,
        InfoBullWidgetComponentModule,
        MultiSelectModule,
        FormsModule,
        ReactiveFormsModule,
        ListFormErrorComponentModule,
    ]
})
export class FormMultiselectComponentModule {
}
